import React from 'react'

import {iconModels} from '../../assets/home-revamp/index'

export default function PoweredByIcons() {
  return (
    <div className='mb-[34px] mx-[10px]'>
      <div className="lg:flex block mx-auto justify-center items-center gap-4 w-fit  lg:mb-[10px]">
        <div>
          <p className="text-sm text-[#00000080] text-center">Powered by Leading AI Models</p>
        </div>
        <div className="flex items-center gap-2 lg:my-0 my-[10px]">
          {iconModels.map(({ name, src }) => (
            <img key={name} src={src} alt={name} className='w-[20px] h-[20px]' />
          ))}
        </div>
      </div>
      <div className='text-center lg:w-[730px] mx-auto'>
        <p className='text-[12px] text-[#00000080] text-center'>AI-Pro is not affiliated with, endorsed by, or sponsored by OpenAI, Anthropic, Google, or their respective AI products. All trademarks are the 
          property of their respective owners. <a href="/disclaimer" target="_blank" rel="noreferrer" className="text-[#3073D5] underline">Learn More</a></p>
      </div>
    </div>
  )
}
